export default __webpack_public_path__ + "static/media/ic_dispatch.59783fc6.svg";